import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '../../../../../../model/user/User';
import { CustomAutocomplete } from '../../../../../../shared/components/Autocomplete';

export interface IInfluencersData {
    setSelectedInfluencerId: any;
    selectedInfluencerId: number;
    influencers: User[] | undefined;
}

export const DetailedPerInfluencerFilter = ({
    setSelectedInfluencerId,
    selectedInfluencerId,
    influencers,
}: IInfluencersData) => {
    const { t } = useTranslation();
    const [selectedInfluencer, setSelectedInfluencer] = useState<User>();

    const changeHandler = (paramKey: string, paramValue: string | string[] | number) => {
        setSelectedInfluencerId({ [paramKey]: +paramValue ? +paramValue : '' });
    };

    useEffect(() => {
        if (!!+selectedInfluencerId && influencers) {
            setSelectedInfluencer(influencers?.find(influencer => +influencer?.id! === +selectedInfluencerId));
        }
    }, [JSON.stringify(selectedInfluencerId), JSON.stringify(influencers)]);

    return (
        <div className="d-flex align-items-md-center justify-content-between flex-column flex-md-row mt-5 mb-2">
            <h4>{t('brand.campaign.measure.detailedPerInfluencer')}</h4>
            <div className="measure-dropdown cursor-pointer">
                {influencers && (
                    <CustomAutocomplete
                        dataArray={influencers as User[]}
                        isWithImage={true}
                        defaultArray={
                            influencers?.find(influencer => influencer.id === +selectedInfluencerId) as unknown as []
                        }
                        queryFilterKey="influencerId"
                        changeEventKey="displayName"
                        inputLabel="displayName"
                        photoLabel="profilePhoto.path"
                        selectedStateImage={selectedInfluencer?.profilePhoto?.path as string}
                        handleChangeParams={changeHandler}
                        inputLabelTranslation={t('general.allInfluencers')}
                        me={true}
                    />
                )}
            </div>
        </div>
    );
};
